import React, { useState } from 'react';
import { useLocationPermission } from 'utils/useLocationPermission';
import Styles from './LocationStatus.module.scss';

const LocationStatus: React.FC = () => {
  const isLocationEnabled = useLocationPermission();
  const [showTooltip, setShowTooltip] = useState(false);

  // Only show the status bar when location is OFF
  if (isLocationEnabled) {
    return null;
  }

  return (
    <div 
      className={Styles.locationStatus}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <div 
        className={Styles.statusIndicator}
        style={{ 
          backgroundColor: '#aaaaaa' // Gray when location is off
        }}
      />
      <span className={Styles.statusText}>
        Location OFF
      </span>
      
      {showTooltip && (
        <div className={Styles.tooltip}>
          <div className={Styles.tooltipArrow} />
          <div className={Styles.tooltipContent}>
            <h4>Enable Location</h4>
            <p>Click the <span className={Styles.infoIcon}>ⓘ</span> icon next to the address bar and allow location for this site</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default LocationStatus;